import React from 'react';
import clsx from 'clsx';
import {IconButton,SnackbarContent} from '@material-ui/core';
import {CheckCircle,Error,Info,Close,Warning} from '@material-ui/icons';

//css
import StylesCss from './styles';
const useStyles = StylesCss();

const variantIcon = {
    success: CheckCircle,
    warning: Warning,
    error: Error,
    info: Info,
};

export default (props) => {
    const classes = useStyles();
    const { className, message, onClose, variant, ...other } = props;
    const Icon = variantIcon[variant];
  
    return (
      <SnackbarContent
        className={clsx(classes[variant], className)}
        aria-describedby="client-snackbar"
        message={
          <span id="client-snackbar" className={classes.message}>
            <Icon className={clsx(classes.icon, classes.iconVariant)} />
            {message}
          </span>
        }
        action={[
          <IconButton key="close" aria-label="Close" color="inherit" onClick={onClose}>
            <Close className={classes.icon} />
          </IconButton>,
        ]}
        {...other}
      />
    );
};